module.exports = __webpack_public_path__ + "static/media/camera.cad7ef43.svg";